export const items = [
  {
    id: 1,
    icon: "/images/hero-section/emergency-service.svg",
    text: "Pregnancy",
    subtext: "Stage-based guidance",
    bgColor: "bg-primary/15",
    innerBg: "bg-primary/15",
  },
  {
    id: 2,
    icon: "/images/hero-section/partner-hospital.svg",
    text: "Postpartum",
    subtext: "Continuity of support",
    bgColor: "bg-primary/20",
    innerBg: "bg-primary/20",
  },
  {
    id: 3,
    icon: "/images/hero-section/free-trial.svg",
    text: "Expert-Backed",
    subtext: "Clinically informed",
    bgColor: "bg-primary/20",
    innerBg: "bg-primary/20",
  },
];

export const features = [
  {
    id: 1,
    category: "GUIDANCE",
    title: "Education & Guidance",
    description: "Trusted knowledge for every stage",
    icon: "access.svg",
    items: [
      { prefix: "", text: "Weekly stage-based pregnancy guidance" },
      { prefix: "", text: "Childbirth preparation education" },
      { prefix: "", text: "Postpartum recovery guidance" },
      { prefix: "", text: "Newborn care essentials" },
      { prefix: "", text: "Expert- reviewed health content" },
    ],
    stat: "Weekly",
    statLabel: "UPDATED GUIDANCE",
  },
  {
    id: 2,
    category: "TRACKING",
    title: "Reminders & Checklist",
    description: "Stay on top of every appointment",
    icon: "management.svg",
    items: [
      { prefix: "", text: "Appointment & scan reminders" },
      { prefix: "", text: "Supplement & medication tracking" },
      { prefix: "", text: "Trimesters milestone checklists" },
      { prefix: "", text: "Postpartum recovery milestones" },
      { prefix: "", text: "Baby development check-ins" },
    ],
    stat: "100%",
    statLabel: "MILESTONE COVERAGE",
  },
  {
    id: 3,
    category: "SUPPORT",
    title: "Support & Resources",
    description: "Never alone on your maternal health journey",
    icon: "support.svg",
    items: [
      { prefix: "", text: "Medical community support group" },
      { prefix: "", text: "Expert- led maternal health sessions" },
      { prefix: "", text: "Structured wellbeing check-ins" },
      { prefix: "", text: "Care pathway connections" },
      { prefix: "", text: "Postpartum transition support" },
    ],
    stat: "24/7",
    statLabel: "PARTNER HOSPITALS",
  },
];

export const howItWorksSteps = [
  {
    id: 1,
    step: "Step 01",
    title: "Join the Waitlist",
    description: "Select a plan that fits your pregnancy or postpartum journey",
    icon: "step-1.svg",
  },
  {
    id: 2,
    step: "Step 02",
    title: "Get Considered for the pilot",
    description:
      "We will review and invite early users to test the platform first",
    icon: "step-2.svg",
  },
  {
    id: 3,
    step: "Step 03",
    title: "Receive Weekly Support",
    description:
      "Get structured guidance, reminders, and care, delivered every week.",
    icon: "step-3.svg",
  },
  {
    id: 4,
    step: "Step 04",
    title: "Receive Care",
    description:
      "Get help through community, experts sessions, and guided support options.",
    icon: "step-4.svg",
  },
];

export const maternalJourneyData = [
  {
    id: 1,
    ageRange: "Trimester 1-2",
    title: "Getting Started",
    description:
      "Learn what to expect in early pregnancy, track key and appointments, and get stage based guidance to help you feel informed and confident",
    icon: "flower",
    exploreLink: "#",
  },
  {
    id: 2,
    ageRange: "Trimester 3",
    title: "Getting Ready",
    description:
      "Childbirth preparation, delivery planning, hospital checklists, and experts based education to help you feel ready for the big day.",
    icon: "pregnant",
    exploreLink: "#",
  },
  {
    id: 3,
    ageRange: "0-3 Months Postpartum",
    title: "Recovery & Newborn Care",
    description:
      "Postpartum healing, feeding support, newborn care guidance, and emotional check-ins during the most critical early weeks.",
    icon: "heal",
    exploreLink: "#",
  },
  {
    id: 4,
    ageRange: "3-12 Months Postpartum",
    title: "Thriving After Birth",
    description:
      "Ongoing recovery support, developmental milestones, return-to-life planning, and continued access to community and expert resources.",
    icon: "sun",
    exploreLink: "#",
  },
];

export const featureTrustItems = [
  // /icons/star.svg
  {
    icon: "/images/how-it-works/satisfied-members.svg",
    title: "98% Satisfaction",
    description: "From verified members",
  },
  // /icons/shield.svg
  {
    icon: "/images/how-it-works/hipaa-compliant.svg",
    title: "Privacy - Conscious",
    description: "Your data is protected",
  },
  // /icons/check.svg
  {
    icon: "/images/how-it-works/no-hidden-fees.svg",
    title: "Full Journey Support",
    description: "Pregnancy through postpartum",
  },
];

export const plans = {
  monthly: [
    {
      id: 1,
      badge: "Great for Starting",
      name: "Basic",
      popular: false,
      price: "",
      billed: "",
      features: [],
      cta: "Start Basic",
    },
    {
      id: 2,
      badge: "Most Popular",
      popularLabel: "MOST POPULAR - SAVE 20%",
      name: "Standard",
      popular: true,
      price: "",
      billed: "",
      features: [],
      cta: "Start Standard",
    },
    {
      id: 3,
      badge: "Comprehensive Care",
      name: "Premium",
      popular: false,
      price: "",
      billed: "",
      features: [],
      cta: "Start Premium",
    },
  ],
  yearly: [
    {
      id: 1,
      badge: "Great for Starting",
      name: "Basic",
      popular: false,
      price: "Free",
      billed: "₦000,0.00",
      features: [
        "Weekly pregnancy guidance",
        "Basic milestone checklists",
        "Limited Doctor Consultation",
        "community access",
        "Email support",
      ],
      cta: "Start Basic",
    },
    {
      id: 2,
      badge: "Most Popular",
      popularLabel: "MOST POPULAR - SAVE 20%",
      name: "Standard",
      popular: true,
      price: "00,000",
      billed: "₦0,000/mo",
      features: [
        "Full pregnancy & postpartum guidance",
        "Advanced checklist & reminders",
        "Expert-led maternal sessions",
        "Priority community support",
        "Delivery coverage included",
      ],
      cta: "Start Standard",
    },
    {
      id: 3,
      badge: "Comprehensive Care",
      name: "Premium",
      popular: false,
      price: "00,000",
      billed: "₦0,000/mo",
      features: [
        "Home visit support options",
        "Concierge maternal care service",
        "Telehealth video consultations",
        "Mental health +24/7 hotline",
        "Private hospital network access",
      ],
      cta: "Start Premium",
    },
  ],
};

export const planPerks = [
  {
    id: 1,
    icon: "/images/pricing/cancel.svg",
    description: "Cancel anytime- no hidden fees",
  },
  {
    id: 2,
    icon: "/images/pricing/card.svg",
    description: "Card, Bank Transfer, USSD, Mobile Money",
  },
  {
    id: 3,
    icon: "/images/pricing/delivery.svg",
    description: "All plans include delivery package",
  },
];

export const whyBrimmHQ = [
  {
    id: 1,
    icon: "/images/why/shield.svg",
    title: "Clinically Informed",
    description:
      "Our support approach is grounded in clinical maternal health best practices and guidelines.",
    badge: "Evidence-Based",
    badgeLabel: "",
  },
  {
    id: 2,
    icon: "/images/why/review.svg",
    title: "Expert-Reviewed",
    description:
      "Education content is reviewed by maternal health professionals for accuracy and relevance.",
    badge: "Verified content",
    badgeLabel: "",
  },
  {
    id: 3,
    icon: "/images/why/lock.svg",
    title: "Privacy & Security",
    description:
      "Your health data is encrypted and GDPR-compliant. Only authorized providers can access with your permission.",
    badge: "Data Protected",
    badgeLabel: "",
  },
  {
    id: 4,
    icon: "/images/why/heart.svg",
    title: "Built for Real Needs",
    description:
      "Designed for real maternal needs, not generic wellness content or surface-level tracking.",
    badge: "Purpose Built",
    badgeLabel: "",
  },
  {
    id: 5,
    icon: "/images/why/support.svg",
    title: "24/7 Support",
    description:
      "Emergency hotline, community advice in English, Pidgin, Yoruba, Igbo and Hausa.",
    badge: "24/7",
    badgeLabel: "",
  },
  {
    id: 6,
    icon: "/images/why/pregnancy.svg",
    title: "Reducing Maternal Mortality",
    description:
      "Bridging the gap in maternal healthcare access across Africa. prenatal support and safe delivery for every mother.",
    badge: "#1",
    badgeLabel: "MISSION",
  },
];

export const testimonials = [
  {
    id: 1,
    image: "/images/testimonials/1.webp",
    rating: 5,
    review:
      "I was scared about my first pregnancy but didnt know who to trust. BRIMM HQ gave me weekly guidance and reminders that made me feel less alone. The checklists helped me stay on top of everything.",
    name: "Chioma. O",
    detail: "26, First-Time Mother - Lagos",
  },
  {
    id: 2,
    image: "/images/testimonials/2.webp",
    rating: 5,
    review:
      "After delivery, I felt completely lost. BrimmHQ's postpartum support helped me through recovery, feeding challenges, and the emotional rollercoaster. I wish I'd had this with my first child.",
    name: "Adeola. M",
    detail: "31, Postpartum Mother - Abuja",
  },
  {
    id: 3,
    image: "/images/testimonials/3.webp",
    rating: 5,
    review:
      "As a working mother, finding time for proper prenatal care was always a challenge. BrimmHQ simplified everything, from scheduling checkups to tracking my supplements. It truly understands a mother's needs.",
    name: "Adeeze. K",
    detail: "34, Senior Finance Executive - Lagos",
  },
  {
    id: 4,
    image: "/images/testimonials/4.webp",
    rating: 5,
    review:
      "The community support group was a lifesaver. Connecting with other mothers going through the same stage made such a difference. The expert sessions on newborn care gave me real confidence.",
    name: "Nana Umar. K",
    detail: "28, New Mother - Abuja",
  },
];

export const testimonialStats = [
  {
    id: 1,
    stat: "98%",
    label: "Satisfaction Rate",
  },
  {
    id: 2,
    stat: "10K+",
    label: "Happy Mothers",
  },
];

export const blogCategories = [
  {
    id: 0,
    label: "All",
    color: "bg-[#0052cc]/20",
    dotColor: "bg-[#0052cc]",
    textColor: "text-[#0052cc]",
    ringColor: "ring-[#0052cc]",
  },
  {
    id: 1,
    label: "Pregnancy",
    color: "bg-[#EEA7AA]/20",
    dotColor: "bg-[#EEA7AA]",
    textColor: "text-[#EEA7AA]",
    ringColor: "ring-[#EEA7AA]",
  },
  {
    id: 2,
    label: "Menstrual Health",
    color: "bg-[#51AE97]/20",
    dotColor: "bg-[#51AE97]",
    textColor: "text-[#51AE97]",
    ringColor: "ring-[#51AE97]",
  },
  {
    id: 3,
    label: "Fertility",
    color: "bg-[#98A5CC]/20",
    dotColor: "bg-[#98A5CC]",
    textColor: "text-[#98A5CC]",
    ringColor: "ring-[#98A5CC]",
  },
  {
    id: 4,
    label: "Menopause",
    color: "bg-[#EEA36B]/20",
    dotColor: "bg-[#EEA36B]",
    textColor: "text-[#EEA36B]",
    ringColor: "ring-[#EEA36B]",
  },
  {
    id: 5,
    label: "Mental Health",
    color: "bg-[#A38CB4]/20",
    dotColor: "bg-[#A38CB4]",
    textColor: "text-[#A38CB4]",
    ringColor: "ring-[#A38CB4]",
  },
  {
    id: 6,
    label: "Wellness",
    color: "bg-[#98C190]/20",
    dotColor: "bg-[#98C190]",
    textColor: "text-[#98C190]",
    ringColor: "ring-[#98C190]",
  },
  {
    id: 7,
    label: "Motherhood",
    color: "bg-[#EBA45C]/20",
    dotColor: "bg-[#EBA45C]",
    textColor: "text-[#EBA45C]",
    ringColor: "ring-[#EBA45C]",
  },
];

export const blogPosts = [
];

export const faqs = [
  {
    id: 1,
    question: "How does the subscription work?",
    answer:
      "You select a plan, pay monthly or annually, and get immediate access to all included services. Cancel anytime with no penalties.",
  },
  {
    id: 2,
    question: "Is BrimmHQ a hospital or clinic?",
    answer:
      "No. BrimmHQ is a maternal support platform that helps women navigate pregnancy and postpartum with guidance, reminders, education, and support.",
  },
  {
    id: 3,
    question: "Is this only for pregnant women?",
    answer:
      "BrimmHQ supports both pregnancy and postpartum stages. Whether you are currently pregnant or have recently given birth.",
  },
  {
    id: 4,
    question: "Does it cover pregnancy and delivery?",
    answer:
      "Yes! Pregnancy coverage includes prenatal care, delivery kit, and delivery expenses at partner hospitals (up to plan limit).",
  },
  {
    id: 5,
    question: "Who is the pilot for?",
    answer:
      "The pilot is for a smaller group of pregnant women and new mothers who want more structured support through their maternal journey.",
  },
];
